export const pricingData = [
    {
        "title":"Standard",
        "amount":"10",
        "content":[
            {
                "detail":"50GB Disk Space"
            },
            {
                "detail":"50 Email Accounts"
            },
            {
                "detail":"Maintenance"
            },
            {
                "detail":"15 Subdomains"
            }
        ]
    },
    {
        "title":"Premium",
        "amount":"20",
        "content":[
            {
                "detail":"10% on all product"
            },
            {
                "detail":"50 Email Accounts"
            },
            {
                "detail":"Maintenance"
            },
            {
                "detail":"15 Subdomains"
            }
        ]
    },
    {
        "title":"Auther pack",
        "amount":"50",
        "content":[
            {
                "detail":"Upload 50 product"
            },
            {
                "detail":"50 Email Accounts"
            },
            {
                "detail":"Maintenance"
            },
            {
                "detail":"15 Subdomains"
            }
        ]
    },
    {
        "title":"Auther pack",
        "amount":"50",
        "content":[
            {
                "detail":"Upload 50 product"
            },
            {
                "detail":"50 Email Accounts"
            },
            {
                "detail":"Maintenance"
            },
            {
                "detail":"15 Subdomains"
            }
        ]
    }
]

export const simpleCardData=[
    {
        "header":"Standard",
        "amount":"$15",
        "title":"Standard Plan",
        "btnname":"Purchase"
    },
    {
        "header":"Business",
        "amount":"$25",
        "title":"Business Plan",
        "btnname":"Purchase"
    },
    {
        "header":"Premium",
        "amount":"$35",
        "title":"Premium Plan",
        "btnname":"Purchase"
    },
    {
        "header":"Extra",
        "amount":"$45",
        "title":"Extra Plan",
        "btnname":"Purchase"
    }
]